import React from 'react'

export const useDropdownOptions = ({ countries, dict, locale }) => {
  return React.useMemo(() => {
    let defaultCountryValue
    let defaultPhoneCodeValue
    const optionsCountry = []
    const optionsPhoneCode = []

    countries.forEach(country => {
      optionsCountry.push({
        label: dict.locales[country.code],
        value: country.code,
      })
      optionsPhoneCode.push({
        label: country.phoneCode,
        value: country.phoneCode,
      })
      if (locale === country.code) {
        defaultCountryValue = country.code
        defaultPhoneCodeValue = country.phoneCode
      }
    })

    return {
      defaultCountryValue,
      optionsCountry,
      defaultPhoneCodeValue,
      optionsPhoneCode,
    }
  }, [countries, dict, locale])
}
